import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-32 text-center">
      <h1 className="font-head font-extrabold text-3xl">Page not found</h1>
      <p className="text-[var(--rs-muted)] mt-4">The page you're looking for doesn't exist or may have moved.</p>
      <Link to="/" className="btn-primary rounded-lg px-6 py-3 text-sm font-semibold inline-flex items-center gap-2 mt-8">
        <ArrowLeft size={16} /> Back to Home
      </Link>
    </section>
  );
}
